export enum SettingTypeEnum {
  CompanyBranding = 'COMPANY_BRANDING',
  SingleSignOn = 'SINGLE_SIGN_ON',
  SessionControl = 'SESSION_CONTROL',
  DeviceAccessLimitation = 'DEVICE_ACCESS_LIMITATION',
  GroupCreationControl = 'GROUP_CREATION_CONTROL',
  OnlineEditors = 'ONLINE_EDITORS',
  ContributorStorageLimit = 'CONTRIBUTOR_STORAGE_LIMIT',
  CertifiedTimestamping = 'CERTIFIED_TIMESTAMPING',
  AdminRegisteredMemberVisibility = 'ADMIN_REGISTERED_MEMBER_VISIBILITY',
  ExternalFileSharingRestriction = 'EXTERNAL_FILESHARING_RESTRICTION',
  RetentionPolicies = 'RETENTION_POLICIES',
  TrashRetentionPolicy = 'TRASH_RETENTION_POLICY',
  FolderCreationPermission = 'FOLDER_CREATION_PERMISSION',
  EditorFileManagement = 'EDITOR_FILE_MANAGEMENT',
  FileTypeRestriction = 'FILE_TYPE_RESTRICTION',
  PublicAccessLink = 'PUBLIC_ACCESS_LINK',
  DownloadRestrictions = 'DOWNLOAD_RESTRICTIONS',
  ForcedAntiCaptureMode = 'FORCED_ANTICAPTURE_MODE',
  UploadWithTag = 'UPLOAD_WITH_TAG',
  FileSalesPermission = 'FILE_SALES_PERMISSION',
  WatermarkProtection = 'WATERMARK_PROTECTION',
  FileSizeLimit = 'FILESIZE_LIMIT',
  OnBehalfMode = 'ONBEHALF_MODE',
  RemotegrantForceEncryption = 'REMOTEGRANT_FORCE_ENCRYPTION',
  AiTagging = 'AI_TAGGING',
  FileDeletionRestriction = 'FILE_DELETION_RESTRICTION',
  AiFileSummary = 'AI_FILESUMMARY',
  AiFileChat = 'AI_FILECHAT',
  AiScraping = 'AI_SCRAPING',
  ResharingPermission = 'RESHARING_PERMISSION',
  FileVersioningRetentionPolicies = 'FILE_VERSIONING_RETENTION_POLICIES',
  MandatoryExpirationSharedFile = 'MANDATORY_EXPIRATION_SHARED_FILE',
  FileTagManagement = 'FILE_TAG_MANAGEMENT',
  FileTagAdditionRestriction = 'FILE_TAG_ADDITION_RESTRICTION',
  SecureFileLocalAccess = 'SECURE_FILE_LOCAL_ACCESS',
  TagBasedAccessControl = 'TAG_BASED_ACCESS_CONTROL',
  FileSharingApproval = 'FILE_SHARING_APPROVAL',
  MandatoryFileClassification = 'MANDATORY_FILE_CLASSIFICATION',
  ForcedFileInvisibility = 'FORCED_FILE_INVISIBILITY',
  ShortcutLink = 'SHORTCUT_LINK',
  AdminSettingsPermissions = 'ADMIN_SETTINGS_PERMISSIONS',
  DownloadAllowedTags = 'DOWNLOAD_ALLOWED_TAGS',
  QuickShareMode = 'QUICKSHARE_MODE',
  IpRegionRestriction = 'IP_REGION_RESTRICTION',
  TotpRequired = 'TOTP_REQUIRED',
  EmailCustomizations = 'EMAIL_CUSTOMIZATIONS',
  OutboundEmail = 'OUTBOUND_EMAIL',
  PasskeySettings = 'PASSKEY_SETTINGS',
  SecurityAnalysis = 'SECURITY_ANALYSIS',
  ActivityLogRetention = 'ACTIVITY_LOG_RETENTION',
  SharePointIntegration = 'SHAREPOINT_INTEGRATION',
  ActiveDirectoryLdap = 'ACTIVE_DIRECTORY_LDAP',
  AntivirusScan = 'ANTIVIRUS_SCAN',
}
